/**
 * [ File :: BaseCanvas.js ]
 *
 * @주의 : TODO 레거시코드 삭제해야함
 */

const BaseCanvas = (function(){

    // [D]
	let _canvas = new WeakMap();

	return class {

		constructor(canvas) {
		    // [T]
		    // console.log("Base create");

			// [S]
			_canvas.set(this, canvas);
		}

		// [V]

		// @DES :: canvas[obj] - 캔버스 객체
		getCanvas() { return _canvas.get(this); }
		setCanvas() { }

		// [F]

	}
}());

export default BaseCanvas;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/scripts/BaseCanvas.js